import clsx from "clsx"
import { paymentStatus } from "@/app/utils/constants"

const Pill = ({ status }) => {  
  return (
    <>
      <span className={clsx("font-light font-agcasmlt text-[12px] tracking-wider leading-3 rounded-full text-white mb-0 ml-1 pt-1 pb-0.5 px-2", { "bg-red-500": status == paymentStatus[5] || status == paymentStatus[4], "bg-green-500": status == paymentStatus[3], "bg-yellow-500": status == paymentStatus[0], "bg-blue-500": status == paymentStatus[1] || status == paymentStatus[2].status })}>{
        status == paymentStatus[5] ? "Failed" : status == paymentStatus[4] ? "Canceled" : status == paymentStatus[3] ? "Completed" : status == paymentStatus[0] ? "Unpaid" : "Paid"
      }</span>
    </>
  )
}

export default Pill